export const CalendarGridMode = {
  agenda: 'agenda',
  day: 'day',
  month: 'month',
  week: 'week',
}

export const CALENDAR_GRID_MODES_ALL = [
  CalendarGridMode.day,
  CalendarGridMode.week,
  CalendarGridMode.month,
  CalendarGridMode.agenda,
]

export const CalendarGridItemVariant = {
  brand: 'brand',
  free: 'free',
  gold: 'gold',
  green: 'green',
  muted: 'muted',
}

export const CALENDAR_GRID_LABEL_SEPARATOR = ' · '
